export default "__VITE_ASSET__BMS7SNzq__"